
<div>
  <b-dropdown-item
    v-if="isCurrentApp"
    active
    class="current-app-dropdown-item"
  >
    <img
      class="webtool-icon-dropdown"
      :src="iconSrc"
      alt=""
    />{{ label }}
  </b-dropdown-item>
  <b-dropdown-item
    v-else
    :href="appLink"
    data-app-nav
    class="other-app-dropdown-item"
  >
    <img
      class="webtool-icon-dropdown"
      :src="iconSrc"
      alt=""
    />{{ label }}
  </b-dropdown-item>
</div>
